import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FileUploadService } from '../services/file-upload.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-upload-doc',
  templateUrl: './upload-doc.component.html',
  styleUrls: ['./upload-doc.component.scss']
})
export class UploadDocComponent implements AfterViewInit {

  fileToUpload: File = null;
  public tin : string = ""
  public filename: string = "";
  progress: number = 0;
  public message:string = "";
  public tinIsValid:boolean;
  @ViewChild("progress_bar", {static: false}) progress_bar: ElementRef;
  @ViewChild("progress_status", {static: false}) progress_status: ElementRef;
  @ViewChild("progress_wrapper", {static: false}) progress_wrapper: ElementRef;
  @ViewChild("input_file",{static:false}) input_file:ElementRef;
  @ViewChild("file_input_label", {static: false}) file_input_label: ElementRef;
  @ViewChild("alert_wrapper", {static: false}) alert_wrapper: ElementRef;
  @ViewChild("upload_btn", {static: false}) upload_btn: ElementRef;
  @ViewChild("loading_btn", {static: false}) loading_btn: ElementRef;

  public constructor(private fileUploadService : FileUploadService){}
 

  ngAfterViewInit(): void {
   // this.file_input_label.nativeElement.innerText = this.input_file.nativeElement.value;
    //this.upload_btn.nativeElement.classList.remove("d-none");
    //this.loading_btn.nativeElement.classList.add("d-none");
  }

  handleFileInput(files: FileList) {
    this.file_input_label.nativeElement.innerText = this.input_file.nativeElement.value;
    if(!files.item(0).type.match("application/pdf")){
      this.fileToUpload = null;
      alert("Please Upload a PDF Document")
     
      return;
    }
    if(files.item(0).size>=2*1024*1024){
      this.fileToUpload = null;
      alert("File size should not be more than 2mb")
      this.input_file.nativeElement.value="";
      this.file_input_label.nativeElement.innerText="";
      return;
    }
    this.fileToUpload = files.item(0);
  }

  uploadFileToActivity(form: NgForm) {
    this.upload_btn.nativeElement.classList.add("d-none");
    this.loading_btn.nativeElement.classList.remove("d-none");
    this.progress_wrapper.nativeElement.classList.remove("d-none");
    this.fileUploadService.postFile(this.tin,this.fileToUpload).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.Sent:
          console.log('Request has been made!');
          break;
        case HttpEventType.ResponseHeader:
          console.log('Response header has been received!');
          break;
        case HttpEventType.UploadProgress:
          this.progress = Math.round(event.loaded / event.total * 100);
          this.progress_bar.nativeElement.setAttribute('style', 'width: ${this.progress}%');
          this.progress_status.nativeElement.innerText=this.progress+"% Uploaded";
          console.log(`Uploaded! ${this.progress}%`);
         // alert('Document upload successful!');
          break;
        case HttpEventType.Response:
          if(event.status==200){
            Swal.fire("Document upload successful!!"+event.body);
            setTimeout(() => {
              this.progress = 0;
              this.upload_btn.nativeElement.classList.remove("d-none");
              this.loading_btn.nativeElement.classList.add("d-none");
              this.progress_wrapper.nativeElement.classList.add("d-none");
            }, 1500);
          }
          else{
            Swal.fire("Error uploading file!!"+event.body);
          }
         
      }
     
    })
    form.reset(); // or form.resetForm()
  }

  public setTinValue(value){
    this.tin = value;
    console.log(this.tin);
  }

  public checkTin(){
    this.fileUploadService.validateTin(this.tin).subscribe(
      data =>{
        if(this.tin===data.FISCAL_NO){
            this.message = "TIN IS VALID"
            this.tinIsValid = true;
            console.log(this.message)
        }
        else{
          this.message = "TIN IS INVALID"
          this.tinIsValid = false;
          console.log(this.message)
        }
        
      }
    )
  }

}
